<template>
  <section class="batch-modify bm-title">
    <header class="batch-head">
      <div class="crumb">
        <button @click="$emit('back')">‹ 返回</button>
        <span>
          商品工作台　›　批量修改　›　
          <strong>标题</strong>
        </span>
        <a>帮助教程</a>
      </div>
      <h1>批量修改标题</h1>
      <nav>
        <button :class="{ active: mode === 'range' }" @click="switchMode('range')">按范围修改</button>
        <button :class="{ active: mode === 'goods' }" @click="switchMode('goods')">按商品修改</button>
      </nav>
    </header>
    <main class="bm-title__body">
      <section class="panel">
        <div v-if="mode === 'goods'" class="picked">
          <button @click="openSelector">选择商品</button>
          <span>
            已选择
            <b>{{ selected.length }}</b>
            个商品
          </span>
        </div>
        <div v-if="mode === 'range'" class="filters">
          <label v-for="field in shownSearchFields" :key="field.key" class="field">
            <span>
              {{ field.label }}
              <small v-if="field.runtime">（需核验数据）</small>
            </span>
            <doudian-category-cascader
              v-if="field.key === 'category_id'"
              v-model="filterValues.category_id"
              :categories="categoryTree" />
            <el-date-picker
              v-else-if="field.date"
              v-model="filterValues[field.key]"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始时间"
              end-placeholder="结束时间" />
            <div v-else-if="field.matchKey" class="combined-control">
              <el-select v-model="filterValues[field.matchKey]" :aria-label="field.label + '匹配方式'">
                <el-option
                  v-for="option in field.matchOptions"
                  :key="option.value"
                  :value="option.value"
                  :label="option.label" />
              </el-select>
              <div v-if="field.range" class="range">
                <input
                  v-model="filterValues[field.key + '_min']"
                  :aria-label="field.label + '最小值'"
                  placeholder="最小值" />
                <span>~</span>
                <input
                  v-model="filterValues[field.key + '_max']"
                  :aria-label="field.label + '最大值'"
                  placeholder="最大值" />
              </div>
              <input
                v-else
                v-model="filterValues[field.key]"
                :aria-label="field.label"
                :disabled="filterValues[field.matchKey] === 'empty'"
                :placeholder="
                  filterValues[field.matchKey] === 'empty' ? '无需填写' : field.placeholder || '请输入' + field.label
                " />
            </div>
            <div v-else-if="field.range" class="range">
              <input v-model="filterValues[field.key + '_min']" placeholder="最小值" />
              <span>~</span>
              <input v-model="filterValues[field.key + '_max']" placeholder="最大值" />
            </div>
            <el-select v-else-if="field.options" v-model="filterValues[field.key]" clearable>
              <el-option
                v-for="option in field.options"
                :key="String(option.value)"
                :value="option.value"
                :label="option.label" />
            </el-select>
            <input v-else v-model="filterValues[field.key]" :placeholder="field.placeholder || '请输入条件'" />
          </label>
        </div>
        <footer v-if="mode === 'range'" class="filter-actions">
          <div class="shops">
            <el-select v-model="store" multiple collapse-tags placeholder="选择抖店" :disabled="confirming">
              <el-option-group v-if="selectableSearchShops.length" label="抖店">
                <el-option
                  v-for="shop in selectableSearchShops"
                  :key="shop.mer_shop_id"
                  :value="Number(shop.mer_shop_id)"
                  :label="shop.shop_name">
                  {{ shop.shop_name }}
                </el-option>
              </el-option-group>
            </el-select>
          </div>
          <div class="filter-buttons">
            <button class="more-search" @click="searchMore = !searchMore">
              {{ searchMore ? '收起更多搜索 ▴' : '更多搜索 ▾' }}
            </button>
            <button :disabled="loading || confirming" @click="loadPreview(1)">查询</button>
            <button class="plain" @click="resetFilters">重置</button>
          </div>
        </footer>
        <p v-if="mode === 'range'" class="hint">
          不同条件同时满足才命中；一个 SKU 满足已设置的 SKU
          条件即可命中商品。条件筛选有些无法直接查询结果，通过数据命中来判断是否符合。
        </p>
      </section>
      <doudian-batch-common-options v-model="commonOptions" :disabled="loading || confirming" />
      <section class="bm-title__fail">
        <strong>标题超长容错：</strong>
        <label>
          <input v-model="failMode" :value="241" type="radio" name="failMode" @change="failModeChanged" />
          按失败处理
        </label>
        <label>
          <input v-model="failMode" :value="242" type="radio" name="failMode" @change="failModeChanged" />
          自动删除标题后面的相应字数
        </label>
      </section>
      <section class="panel methods">
        <h3>
          <i></i>
          修改内容
        </h3>
        <article v-for="(method, index) in methods" :key="method.name" class="rule-row">
          <el-checkbox
            v-model="method.on"
            :disabled="index === 1"
            @change="handleMethodChange(index, $event)"
            class="bm-title__method-name">
            方式{{ index + 1 }}：{{ method.name }}
          </el-checkbox>
          <div class="rule-options">
            <template v-if="index === 0">
              <span>热搜词</span>
              <input v-model="form.hotWords" placeholder="输入热搜词，多个词用逗号分隔" />
              <el-select v-model="form.hotPosition" class="bm-title__select">
                <el-option label="添加到标题前面" :value="201" />
                <el-option label="添加到标题后面" :value="202" />
              </el-select>
            </template>
            <template v-else-if="index === 1">
              <label>
                <input v-model="form.aiMode" value="AI智能生成标题" type="radio" />
                AI智能生成标题
              </label>
              <label>
                <input v-model="form.aiMode" value="AI标题拆词重组" type="radio" />
                AI标题拆词重组
              </label>
            </template>
            <template v-else-if="index === 2">
              <div class="bm-title__count-input">
                <input v-model="form.newTitle" class="long" maxlength="60" placeholder="请输入新标题内容" />
                <small>{{ form.newTitle.length }}/60</small>
              </div>
            </template>
            <template v-else-if="index === 3">
              <div class="bm-title__count-textarea">
                <textarea
                  v-model="form.keywords"
                  maxlength="10000"
                  placeholder="多个关键词用逗号分隔，最多10000字"></textarea>
                <small>{{ form.keywords.length }}/10000</small>
              </div>
              <span>如果关键字命中原标题中2个及以上重复词，则</span>
              <el-checkbox v-model="form.repeatEnabled">启用重复词处理</el-checkbox>
              <el-select v-model="form.repeatRule" :disabled="!form.repeatEnabled" class="bm-title__select">
                <el-option label="保留第一个" :value="211" />
                <el-option label="全部替换" :value="212" />
              </el-select>
              <small class="warning">请慎重选择此选项</small>
            </template>
            <template v-else-if="index === 4">
              <el-checkbox
                v-for="option in filterOptions"
                :key="option.value"
                v-model="form.filters"
                :label="option.value">
                {{ option.label }}
              </el-checkbox>
            </template>
            <template v-else-if="index === 5">
              <label>
                <input v-model="form.caseRule" :value="221" type="radio" />
                标题英文部分转小写
              </label>
              <label>
                <input v-model="form.caseRule" :value="222" type="radio" />
                标题英文部分转大写
              </label>
            </template>
            <template v-else-if="index === 6">
              <div v-for="(replace, replaceIndex) in form.replaces" :key="replaceIndex" class="bm-title__replace">
                <input v-model="replace.find" placeholder="查找内容" />
                <span>→</span>
                <input v-model="replace.value" placeholder="替换为" />
                <button @click="addReplace">＋ 添加</button>
                <button v-if="replaceIndex" class="danger" @click="removeReplace(replaceIndex)">删除</button>
              </div>
              <el-checkbox v-model="form.replaceTrim">超长自动删减</el-checkbox>
              <small v-if="form.replaceTrim" class="warning">
                如果修改后的标题超过类目字符限制，自动从原标题的尾部删除相应字数
              </small>
            </template>
            <template v-else-if="index === 7">
              <div class="bm-title__inline">
                <span>前缀</span>
                <input v-model="form.prefix" placeholder="前缀内容" />
                <span>后缀</span>
                <input v-model="form.suffix" placeholder="后缀内容" />
              </div>
              <div class="bm-title__inline">
                <el-checkbox v-model="form.addSkuNo">若商品有货号，将货号添加到标题</el-checkbox>
                <el-select v-model="form.skuNoPosition" :disabled="!form.addSkuNo" class="bm-title__select">
                  <el-option label="添加到标题前面" :value="231" />
                  <el-option label="添加到标题后面" :value="232" />
                </el-select>
              </div>
              <el-checkbox v-model="form.prefixTrim">超长自动删减</el-checkbox>
              <small v-if="form.prefixTrim" class="warning">
                如果修改后的标题超过类目字符限制，自动从原标题的尾部删除相应字数
              </small>
            </template>
            <template v-else-if="index === 8">
              <span>删除首部字数</span>
              <el-select v-model="form.head" class="bm-title__select">
                <el-option v-for="item in numberOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
              <span>删除尾部字数</span>
              <el-select v-model="form.tail" class="bm-title__select">
                <el-option v-for="item in numberOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </template>
            <template v-else>
              <span>替换前内容</span>
              <input v-model="form.before" placeholder="原前缀" />
              <span>替换后内容</span>
              <input v-model="form.after" placeholder="新前缀" />
              <small class="warning">将替换相应的字数，无需替换则为空</small>
            </template>
          </div>
        </article>
      </section>
      <section v-if="preview" class="bm-title__preview">
        <doudian-batch-preview-notice />
        <header>
          已选择
          <b>{{ mode === 'goods' ? selected.length : previewPage.total }}</b>
          个商品，当前预览
          <b>{{ previewPage.total }}</b>
          个，已排除 {{ excludedProductIds.length }} 个
          <button @click="preview = false">收起预览</button>
        </header>
        <table>
          <colgroup>
            <col class="bm-title__col-product" />
            <col class="bm-title__col-new-title" />
            <col class="bm-title__col-action" />
          </colgroup>
          <thead>
            <tr>
              <th>商品信息</th>
              <th>调整后标题</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(good, n) in previewGoods"
              :key="good.id || good.product_id || n"
              :class="{
                'is-excluded': isExcluded(good),
                'is-error': isPreviewError(good)
              }">
              <td>
                <div class="bm-title__product-info">
                  <el-image
                    class="bm-title__image"
                    :src="imageOf(good)"
                    fit="cover"
                    :preview-src-list="[imageOf(good)]" />
                  <div>
                    <div class="bm-title__product-ids">
                      <small>商品ID：{{ productId(good) }}</small>
                      <small v-if="good.platform_product_id">平台商品ID：{{ good.platform_product_id }}</small>
                    </div>
                    <p>{{ titleOf(good) }}</p>
                  </div>
                </div>
              </td>
              <td>
                <textarea
                  :value="good.new_title"
                  readonly
                  :class="{
                    'is-error': isPreviewError(good),
                    'is-unchanged': isUnchangedPreviewTitle(good)
                  }"></textarea>
                <div v-if="good.match_reason" class="bm-title__preview-error">{{ good.match_reason }}</div>
                <div v-if="good.is_skipped || good.shelf_only" class="bm-title__preview-error">
                  {{ good.shelf_only ? '标题未变化，检查尺码表后调整上下架' : '内容未变化，跳过修改' }}
                </div>
                <div v-if="isPreviewError(good) && good.error_msg" class="bm-title__preview-error">
                  {{ good.error_msg }}
                </div>
              </td>
              <td>
                <button :class="{ 'is-excluded': isExcluded(good) }" @click="toggleExclude(good)">
                  {{ isExcluded(good) ? '取消排除' : '排除修改' }}
                </button>
              </td>
            </tr>
            <tr v-if="!loading && previewGoods.length === 0" class="bm-title__empty-row">
              <td colspan="3">暂无数据</td>
            </tr>
          </tbody>
        </table>
        <footer class="bm-title__pagination">
          <span class="bm-title__pagination-total">共 {{ previewPage.total }} 条</span>
          <div class="bm-title__pagination-actions">
            <el-pagination
              :current-page="previewPage.page"
              :page-size="previewPage.limit"
              :total="previewPage.total"
              layout="prev, pager, next"
              small
              @current-change="loadPreview" />
            <span class="bm-title__pagination-jump">
              前往
              <input v-model.number="previewJumpPage" min="1" type="number" @keyup.enter="jumpPreviewPage" />
              页
            </span>
          </div>
        </footer>
      </section>
    </main>
    <footer class="bm-title__bottom">
      <button class="preview" @click="loadPreview()">修改内容预览</button>
      <button class="start" :disabled="loading || confirming" @click="startBatch">开始批量修改</button>
      <label>
        <input v-model="scheduled" type="checkbox" @change="toggleSchedule" />
        定时执行
      </label>
      <button v-if="scheduled" class="time" @click="openSchedule">
        {{ scheduleText }}
      </button>
    </footer>
    <div v-if="moreSearch" class="bm-title__mask">
      <div class="bm-title__more-modal">
        <header>
          <strong>支持更多搜索</strong>
          <button @click="moreSearch = false">×</button>
        </header>
        <main>
          <el-checkbox-group v-model="moreSearchDraft">
            <el-checkbox v-for="field in moreSearchFields" :key="field" :label="field">{{ field }}</el-checkbox>
          </el-checkbox-group>
        </main>
        <footer>
          <button class="plain" @click="resetMoreSearch">重置默认</button>
          <button class="plain" @click="closeMoreSearch">取消</button>
          <button @click="applyMoreSearch">应用</button>
        </footer>
      </div>
    </div>
    <product-selector-dialog
      :visible="selecting"
      :active-tab="selectorTab"
      :products="selectorTab === 'all' ? goods : selectedPageGoods"
      :selected-ids="selectorSelected"
      :loading="selectorTab === 'all' && selectorLoading"
      :page="selectorDialogPage"
      :page-size="selectorPage.limit"
      :page-sizes="[20, 50, 100]"
      :total="selectorDialogTotal"
      :total-pages="selectorDialogPageCount"
      :jump-page="selectorDialogJumpPage"
      :page-fully-selected="isPageFullySelected"
      :product-id="productId"
      :product-key="productId"
      :product-title="titleOf"
      :product-image="imageOf"
      :product-price="priceOf"
      @close="closeSelector"
      @confirm="confirmSelector"
      @tab-change="switchSelectorTab"
      @toggle-product="toggleGood"
      @toggle-page="togglePageSelection"
      @page-change="changeSelectorPage"
      @page-size-change="changeSelectorPageSize"
      @jump-input="changeSelectorJumpPage"
      @jump="jumpSelectorPage">
      <template #filters>
        <doudian-product-selector-filters
          :value="selectorFilters"
          :shop-id="selectorShopId"
          :shops="selectableSearchShops"
          :categories="categoryTree"
          @shop-change="changeSelectorShop"
          @query="querySelector" />
      </template>
    </product-selector-dialog>
    <div v-if="schedule" class="bm-title__mask">
      <div class="bm-title__small-modal">
        <header>
          <strong>定时执行</strong>
          <button @click="closeSchedule">×</button>
        </header>
        <main>
          <label>
            执行时间
            <el-date-picker
              v-model="scheduleDraft"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              placeholder="请选择执行时间"
              :clearable="false"
              popper-class="bm-title__schedule-popper"
              class="bm-title__schedule-picker" />
          </label>
        </main>
        <footer>
          <button class="plain" @click="closeSchedule">取消</button>
          <button @click="confirmSchedule">确定</button>
        </footer>
      </div>
    </div>
    <div v-if="success" class="bm-title__mask">
      <div class="bm-title__small-modal">
        <header>
          <strong>提示</strong>
          <button @click="success = false">×</button>
        </header>
        <main class="success-message">
          <b>✓</b>
          <p>批量修改任务创建成功</p>
          <small>任务将在后台处理，请在批量修改记录中查看进度。</small>
        </main>
        <footer><button @click="success = false">我知道了</button></footer>
      </div>
    </div>
  </section>
</template>

<script>
import { fields as sharedSearchFields, pairedFields, defaults as searchDefaults } from './batchModifyFilters'
import { buildBatchProductFilter } from './batchModifyFilters'

import {
  createDoudianTitleBatch,
  previewDoudianTitleBatch,
  getDoudianCategories,
  getAuthSuccessShopList,
  getProductSelectorProducts
} from '@/api/main/doudianBatchEdit'
import DoudianCategoryCascader from '@/components/DoudianCategoryCascader'
import ProductSelectorDialog from '@/components/ProductSelectorDialog/ProductSelectorDialog'
import DoudianProductSelectorFilters from './DoudianProductSelectorFilters.vue'
import DoudianBatchCommonOptions, {
  describeCommonOptions,
  batchPreviewNotice
} from '@/components/DoudianBatchCommonOptions'
import DoudianBatchPreviewNotice from '@/components/DoudianBatchCommonOptions/PreviewNotice.vue'

const fields = [
  { key: 'category_id', label: '商品分类', select: true, options: [] },
  {
    key: 'status',
    label: '商品状态',
    select: true,
    options: [
      { value: 3, label: '在售' },
      { value: 4, label: '仓库中' },
      { value: 6, label: '草稿' }
    ]
  },
  { key: 'product_title', label: '标题包含', placeholder: '请输入标题关键词' },
  { key: 'platform_product_id', label: '抖店商品ID', placeholder: '请输入抖店商品ID' },
  { key: 'price_range', label: '售价范围（元）', range: true, rangeKeys: ['price_min', 'price_max'] },
  { key: 'created_at', label: '创建时间', datetimeRange: true },
  { key: 'sales_range', label: '销量（件）', range: true, rangeKeys: ['sales_min', 'sales_max'] }
]
const defaultFilterValues = fields.reduce((values, field) => {
  if (field.datetimeRange) values[field.key] = []
  else if (field.range)
    field.rangeKeys.forEach((key) => {
      values[key] = ''
    })
  else if (field.key === 'category_id') values[field.key] = { level1: [], level2: [], level3: [] }
  else values[field.key] = ''
  return values
}, {})
export default {
  name: 'BatchModifyTitle',
  components: {
    DoudianBatchCommonOptions,
    DoudianBatchPreviewNotice,
    DoudianCategoryCascader,
    DoudianProductSelectorFilters,
    ProductSelectorDialog
  },
  data() {
    return {
      mode: 'range',
      fields,
      filterValues: searchDefaults(),
      searchMore: false,
      store: [],
      shops: [],
      moreSearch: false,
      moreSearchFields: fields.map((field) => field.label),
      moreSearchChecked: fields.map((field) => field.label),
      moreSearchDraft: [],
      failMode: 242,
      commonOptions: { auto_generate_size_chart: false, shelf_action: 0 },
      preview: false,
      previewGoods: [],
      previewPage: { page: 1, limit: 20, total: 0 },
      previewJumpPage: 1,
      previewSignature: '',
      previewRequestId: 0,
      selectorRequestId: 0,
      confirming: false,
      excludedProductIds: [],
      loading: false,
      selecting: false,
      selectorTab: 'all',
      selectorShopId: '',
      selectorFilters: {
        category_id: { level1: [], level2: [], level3: [] },
        platform_product_id: '',
        product_title: '',
        created_at: [],
        tab_status: ''
      },
      selectorPage: { page: 1, limit: 20, total: 0 },
      selectorJumpPage: 1,
      selectedPage: 1,
      selectedJumpPage: 1,
      selectorLoading: false,
      success: false,
      schedule: false,
      scheduled: false,
      scheduleText: '',
      scheduleDraft: '',
      selected: [],
      selectedGoods: [],
      selectorSelected: [],
      selectorSelectedGoods: [],
      numberOptions: [
        { value: 0, label: '0（不删除）' },
        { value: 1, label: '1' },
        { value: 2, label: '2' },
        { value: 3, label: '3' },
        { value: 5, label: '5' },
        { value: 10, label: '10' }
      ],
      methods: [
        '批量补充热搜词',
        '重新生成标题',
        '使用新内容',
        '删除关键字',
        '过滤内容',
        '英文转大小写',
        '商品关键字替换',
        '增加前缀/后缀',
        '删除首尾字数',
        '替换前缀内容'
      ].map((name, index) => ({
        type: [101, 102, 103, 104, 105, 106, 107, 108, 109, 110][index],
        name,
        on: false
      })),
      form: {
        hotWords: '',
        hotPosition: 201,
        aiMode: 'AI智能生成标题',
        newTitle: '',
        keywords: '',
        repeatEnabled: false,
        repeatRule: 211,
        filters: [],
        caseRule: 221,
        replaces: [{ find: '', value: '' }],
        replaceTrim: false,
        prefix: '',
        suffix: '',
        addSkuNo: false,
        skuNoPosition: 231,
        prefixTrim: false,
        head: 0,
        tail: 0,
        before: '',
        after: ''
      },
      filterOptions: [
        { label: '去除英文', value: 301 },
        { label: '去除数字', value: 302 },
        { label: '去除全部空格', value: 303 },
        { label: '仅去除首尾空格', value: 304 },
        { label: '去除英文符号', value: 305 },
        { label: '去除货号', value: 306 },
        { label: '去除括号及内容', value: 307 },
        { label: '去除逗号', value: 308 }
      ],
      goods: [],
      categoryTree: []
    }
  },
  computed: {
    selectableSearchShops() {
      return this.shops.filter((shop) => Number(shop.shop_type) !== 2 && shop.selectable !== false)
    },
    shownSearchFields() {
      return sharedSearchFields
        .filter(
          (field) =>
            !Object.values(pairedFields).includes(field.key) &&
            (!field.more || this.searchMore) &&
            (this.mode === 'range' ||
              !['platform_product_id', 'created_at', 'category_id', 'status'].includes(field.key))
        )
        .map((field) =>
          pairedFields[field.key]
            ? {
                ...field,
                matchKey: pairedFields[field.key],
                matchOptions: sharedSearchFields.find((item) => item.key === pairedFields[field.key]).options
              }
            : field
        )
    },

    visibleFields() {
      return this.fields.filter((field) => this.moreSearchChecked.includes(field.label))
    },
    previewIsCurrent() {
      return this.previewSignature !== '' && this.previewSignature === this.previewPayloadSignature()
    },
    pageCount() {
      return Math.max(1, Math.ceil(Number(this.previewPage.total || 0) / Number(this.previewPage.limit || 20)))
    },
    selectorPageCount() {
      return Math.max(1, Math.ceil(Number(this.selectorPage.total || 0) / Number(this.selectorPage.limit || 20)))
    },
    selectedPageCount() {
      return Math.max(1, Math.ceil(this.selectorSelectedGoods.length / Number(this.selectorPage.limit || 20)))
    },
    selectedPageGoods() {
      const start = (this.selectedPage - 1) * this.selectorPage.limit
      return this.selectorSelectedGoods.slice(start, start + this.selectorPage.limit)
    },
    selectedPlatformProductIds() {
      return this.selectedGoods.map((good) => String(good.platform_product_id || '')).filter(Boolean)
    },
    selectorDialogPage() {
      return this.selectorTab === 'all' ? this.selectorPage.page : this.selectedPage
    },
    selectorDialogTotal() {
      return this.selectorTab === 'all' ? this.selectorPage.total : this.selectorSelectedGoods.length
    },
    selectorDialogPageCount() {
      return this.selectorTab === 'all' ? this.selectorPageCount : this.selectedPageCount
    },
    selectorDialogJumpPage() {
      return this.selectorTab === 'all' ? this.selectorJumpPage : this.selectedJumpPage
    },
    isPageFullySelected() {
      return this.goods.length > 0 && this.goods.every((good) => this.selectorSelected.includes(this.productId(good)))
    },
    shopGroups() {
      const groups = [
        { label: '抖店', options: [], disabled: false },
        { label: '微信小店', options: [], disabled: true }
      ]
      this.shops.forEach((shop) => (Number(shop.shop_type) === 2 ? groups[1].options : groups[0].options).push(shop))
      return groups.filter((group) => group.options.length)
    }
  },
  beforeDestroy() {
    this.previewRequestId++
    this.selectorRequestId++
  },
  mounted() {
    this.loadCategories()
    this.loadShops()
  },
  methods: {
    async loadCategories() {
      try {
        const response = await getDoudianCategories({ shop_type: 1 })
        const data = response && response.data ? response.data : response
        const list = Array.isArray(data) ? data : data.list || data.data || []
        this.categoryTree = this.mapCategoryFields(list)
      } catch (error) {
        this.$message.error('加载商品分类失败')
      }
    },
    async loadShops() {
      try {
        const response = await getAuthSuccessShopList()
        const root = response && response.data ? response.data : response
        this.shops = Array.isArray(root) ? root : (root && (root.list || root.data)) || []
      } catch (error) {
        this.$message.error('加载店铺失败')
      }
    },
    mapCategoryFields(categories) {
      if (!Array.isArray(categories)) return []
      return categories.map((item) => ({
        category_id: item.id || item.category_id,
        category_name: item.name || item.category_name,
        category_parent_id: item.parent_id || item.category_parent_id,
        category_level: item.level || item.category_level,
        category_is_leaf: item.is_leaf || item.category_is_leaf,
        children: item.children ? this.mapCategoryFields(item.children) : []
      }))
    },
    productId(good) {
      return Number(good && (good.id ?? good.product_id ?? good.distribute_product_id ?? good.platform_product_id))
    },
    titleOf(good) {
      return (good && (good.title || good.product_title || good.name)) || ''
    },
    priceOf(good) {
      const value = good && (good.product_price ?? good.price ?? good.min_price)
      return value === undefined || value === null ? '价格待定' : `¥${value}`
    },
    imageOf(good) {
      return (good && (good.main_image || good.img || good.image_url)) || ''
    },
    isPreviewError(good) {
      return Number(good && good.status) === 10
    },
    isUnchangedPreviewTitle(good) {
      const oldTitle = this.titleOf(good)
      return !this.isPreviewError(good) && oldTitle !== '' && good.new_title !== '' && oldTitle === good.new_title
    },
    failModeChanged() {
      this.preview = false
      this.previewGoods = []
      this.previewPage = { ...this.previewPage, page: 1, total: 0 }
      this.previewJumpPage = 1
      this.previewSignature = ''
    },
    cleanValue(value) {
      if (Array.isArray(value)) return value.filter((item) => item !== '' && item !== null && item !== undefined)
      if (value && typeof value === 'object')
        return Object.keys(value).reduce((result, key) => {
          const cleaned = this.cleanValue(value[key])
          if (
            cleaned !== '' &&
            cleaned !== null &&
            cleaned !== undefined &&
            !(Array.isArray(cleaned) && !cleaned.length)
          )
            result[key] = cleaned
          return result
        }, {})
      return value
    },
    buildQueryPayload() {
      const productFilter = buildBatchProductFilter(
        this.filterValues,
        this.store,
        this.excludedProductIds,
        this.mode,
        this.selectedPlatformProductIds
      )
      const rules = this.methods
        .filter((method) => method.on)
        .map((method) => ({
          type: method.type,
          options: this.ruleOptions(method.type)
        }))
      rules.push({ type: 111, options: { mode: this.failMode } })
      const payload = {
        selection_mode: this.mode === 'goods' ? 'products' : 'range',
        product_filter: productFilter,
        rules,
        common_options: { ...this.commonOptions }
      }
      if (this.scheduled && this.scheduleText) payload.scheduled_at = `${this.scheduleText}:00`
      return payload
    },
    previewPayloadSignature(query = this.buildQueryPayload()) {
      const { scheduled_at: ignored, ...payload } = query
      const normalize = (value) => {
        if (Array.isArray(value)) return value.map(normalize)
        if (value && typeof value === 'object')
          return Object.keys(value)
            .sort()
            .reduce((result, key) => ({ ...result, [key]: normalize(value[key]) }), {})
        return value
      }
      return JSON.stringify(normalize(payload))
    },
    handleMethodChange(index, checked) {
      if (!checked) return
      this.methods.forEach((method, methodIndex) => {
        method.on = methodIndex === index
      })
    },
    validateModification() {
      const method = this.methods.find((item) => item.on)
      const form = this.form
      const filled = (value) => String(value == null ? '' : value).trim() !== ''
      const hasWord = (value) =>
        String(value == null ? '' : value)
          .split(/[,，]/)
          .some(filled)
      let message = ''
      if (!method) message = '请至少选择一种修改方式'
      else if (method.type === 101 && !hasWord(form.hotWords)) message = '请输入热搜词'
      else if (method.type === 103 && !filled(form.newTitle)) message = '请输入新标题内容'
      else if (method.type === 104 && !hasWord(form.keywords)) message = '请输入需要删除的关键字'
      else if (method.type === 105 && !form.filters.length) message = '请至少选择一个过滤项'
      else if (method.type === 106 && ![221, 222].includes(Number(form.caseRule))) message = '请选择英文大小写转换方向'
      else if (method.type === 107) {
        const replaces = form.replaces || []
        if (replaces.some((item) => !filled(item.find) && filled(item.value))) message = '请填写替换规则的查找内容'
        else if (!replaces.some((item) => filled(item.find))) message = '请至少填写一组查找内容'
      } else if (method.type === 108 && !filled(form.prefix) && !filled(form.suffix) && !form.addSkuNo)
        message = '请填写前缀或后缀内容'
      else if (method.type === 109 && !(Number(form.head) > 0 || Number(form.tail) > 0))
        message = '请选择需要删除的首部或尾部字数'
      else if (method.type === 110 && !filled(form.before)) message = '请输入替换前的前缀内容'
      if (message) this.$message.warning(message)
      return !message
    },
    ruleOptions(type) {
      const map = {
        101: ['hotWords', 'hotPosition'],
        103: ['newTitle'],
        104: ['keywords', 'repeatEnabled', 'repeatRule'],
        105: ['filters'],
        106: ['caseRule'],
        107: ['replaces', 'replaceTrim'],
        108: ['prefix', 'suffix', 'addSkuNo', 'skuNoPosition', 'prefixTrim'],
        109: ['head', 'tail'],
        110: ['before', 'after']
      }
      const options = (map[type] || []).reduce((result, key) => ({ ...result, [key]: this.form[key] }), {})
      if (type === 102) options.mode = this.form.aiMode
      return options
    },
    parsePageResponse(response) {
      const root = response && response.data ? response.data : response
      const page = root && root.data && !Array.isArray(root.data) ? root.data : root
      const list = Array.isArray(page) ? page : (page && (page.list || page.data)) || []
      return {
        list: Array.isArray(list) ? list : [],
        total: Number(page && page.total !== undefined ? page.total : list.length),
        page: Number((page && (page.current_page || page.currentPage)) || 1),
        limit: Number((page && (page.per_page || page.perPage)) || this.previewPage.limit)
      }
    },
    ensureSuccess(response) {
      if (Number(response && response.code) !== 200) throw new Error(response?.message || response?.msg || '请求失败')
      return response
    },
    async loadPreview(page = 1) {
      if (this.loading || this.confirming) return
      if (!this.validateModification()) return
      if (
        this.mode === 'goods' &&
        (!this.selected.length || this.selectedPlatformProductIds.length !== this.selected.length)
      )
        return this.$message.warning('请选择包含抖店商品ID的商品')
      const { scheduled_at: ignored, ...payload } = JSON.parse(JSON.stringify(this.buildQueryPayload()))
      const signature = this.previewPayloadSignature(payload)
      const requestId = ++this.previewRequestId
      this.loading = true
      try {
        const result = this.parsePageResponse(
          this.ensureSuccess(
            await previewDoudianTitleBatch({
              ...payload,
              page,
              limit: this.previewPage.limit
            })
          )
        )
        if (requestId !== this.previewRequestId || this._isDestroyed || signature !== this.previewPayloadSignature()) {
          if (!this._isDestroyed && requestId === this.previewRequestId) {
            this.previewSignature = ''
            this.$message.warning('修改条件已变化，请重新预览')
          }
          return
        }
        this.previewGoods = Array.isArray(result.list) ? result.list : []
        this.previewPage = {
          page: result.page || page,
          limit: result.limit || this.previewPage.limit,
          total: result.total
        }
        this.previewJumpPage = this.previewPage.page
        this.previewSignature = signature
        this.preview = true
      } catch (error) {
        if (requestId === this.previewRequestId && !this._isDestroyed)
          this.$message.error(error?.response?.data?.message || error?.message || '查询失败')
      } finally {
        if (requestId === this.previewRequestId) this.loading = false
      }
    },
    jumpPreviewPage() {
      const page = Math.min(this.pageCount, Math.max(1, Number(this.previewJumpPage) || 1))
      this.previewJumpPage = page
      if (page !== this.previewPage.page) this.loadPreview(page)
    },
    async startBatch() {
      if (this.loading || this.confirming) return
      if (!this.validateModification()) return
      if (this.scheduled && !this.isFutureSchedule(this.scheduleText))
        return this.$message.warning('定时时间必须晚于当前时间')
      if (
        this.mode === 'goods' &&
        (!this.selected.length || this.selectedPlatformProductIds.length !== this.selected.length)
      )
        return this.$message.warning('请选择包含抖店商品ID的商品')
      if (!this.preview) return this.$message.warning('请先点击修改内容预览')
      if (!this.previewIsCurrent) return this.$message.warning('修改条件已变化，请重新预览')
      if (!this.previewPage.total) return this.$message.warning('当前条件下没有可修改的商品')
      const payload = JSON.parse(JSON.stringify(this.buildQueryPayload()))
      const confirmedPayload = JSON.stringify(payload)
      this.confirming = true
      try {
        const scheduleTip = payload.scheduled_at ? `\n定时执行时间：${payload.scheduled_at}` : ''
        await this.$confirm(
          `商品数${this.previewPage.total}${scheduleTip}\n${batchPreviewNotice}\n${describeCommonOptions(
            payload.common_options
          )}\n是否开始修改？`,
          '确认修改'
        )
        if (this._isDestroyed) return
        if (!this.previewIsCurrent || confirmedPayload !== JSON.stringify(this.buildQueryPayload()))
          return this.$message.warning('修改条件已变化，请重新预览并确认')
        if (payload.scheduled_at && !this.isFutureSchedule(this.scheduleText))
          return this.$message.warning('定时时间必须晚于当前时间')
        this.loading = true
        this.ensureSuccess(await createDoudianTitleBatch(payload))
        if (!this._isDestroyed) {
          this.success = true
          this.$emit('created')
        }
      } catch (error) {
        if (error !== 'cancel' && error !== 'close' && !this._isDestroyed)
          this.$message.error(error?.response?.data?.message || error?.message || '创建任务失败')
      } finally {
        this.loading = false
        this.confirming = false
      }
    },
    confirmSchedule() {
      if (!this.isFutureSchedule(this.scheduleDraft)) return this.$message.warning('请选择未来的执行时间')
      this.scheduleText = this.scheduleDraft
      this.closeSchedule()
    },
    formatScheduleTime(date = new Date(Date.now() + 60000)) {
      const pad = (value) => String(value).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(
        date.getMinutes()
      )}`
    },
    isFutureSchedule(value) {
      return Boolean(value) && new Date(value.replace(' ', 'T')) > new Date()
    },
    toggleSchedule() {
      if (!this.scheduled) {
        this.schedule = false
        this.scheduleText = ''
        this.scheduleDraft = ''
        return
      }
      if (this.scheduled && !this.scheduleText) this.scheduleText = this.formatScheduleTime()
    },
    openSchedule() {
      this.scheduleDraft = this.scheduleText || this.formatScheduleTime()
      this.schedule = true
    },
    closeSchedule() {
      this.schedule = false
      this.scheduleDraft = ''
    },
    changeSelectorShop(shopId) {
      this.selectorShopId = shopId
      this.querySelector()
    },
    async openSelector() {
      this.selectorShopId = this.selectedGoods[0]?.shop_id || ''
      this.selectorSelected = [...this.selected]
      this.selectorSelectedGoods = [...this.selectedGoods]
      this.selecting = true
      this.selectorTab = 'all'
      this.selectedPage = 1
      this.selectedJumpPage = 1
      await this.loadGoods(this.selectorPage.page)
    },
    closeSelector() {
      this.selectorRequestId++
      this.selectorLoading = false
      this.selecting = false
      this.selectorSelected = []
      this.selectorSelectedGoods = []
    },
    confirmSelector(ids) {
      const products = this.selectorSelectedGoods.filter((good) => ids.includes(this.productId(good)))
      const shopId = Number(products[0]?.shop_id)
      if (!shopId || products.some((good) => Number(good.shop_id) !== shopId))
        return this.$message.warning('只能选择同一家店铺的商品')
      this.store = [shopId]
      this.selected = [...ids]
      this.selectedGoods = this.selectorSelectedGoods.filter((good) => this.selected.includes(this.productId(good)))
      this.closeSelector()
    },
    switchMode(mode) {
      if (this.mode === mode) return
      this.mode = mode
      this.filterValues = searchDefaults()
      this.store = []
      this.selected = []
      this.selectedGoods = []
      this.selectorSelected = []
      this.selectorSelectedGoods = []
      this.selectedPage = 1
      this.selectedJumpPage = 1
      this.excludedProductIds = []
      this.previewGoods = []
      this.previewPage = { ...this.previewPage, page: 1, total: 0 }
      this.previewJumpPage = 1
      this.previewSignature = ''
      this.preview = false
      this.selecting = false
    },
    switchSelectorTab(tab) {
      this.selectorTab = tab
      if (tab === 'selected') {
        this.selectedPage = 1
        this.selectedJumpPage = 1
      }
    },
    querySelector() {
      this.loadGoods(1)
    },
    async loadGoods(page = 1) {
      const filters = JSON.parse(
        JSON.stringify(
          this.cleanValue({
            ...this.selectorFilters,
            ...(this.selectorShopId ? { shop_ids: [this.selectorShopId] } : {})
          })
        )
      )
      const signature = JSON.stringify(filters)
      const pageSize = this.selectorPage.limit
      const requestId = ++this.selectorRequestId
      this.selectorLoading = true
      try {
        const response = this.ensureSuccess(await getProductSelectorProducts({ ...filters, page, page_size: pageSize }))
        if (
          requestId !== this.selectorRequestId ||
          !this.selecting ||
          this._isDestroyed ||
          signature !==
            JSON.stringify(
              this.cleanValue({
                ...this.selectorFilters,
                ...(this.selectorShopId ? { shop_ids: [this.selectorShopId] } : {})
              })
            ) ||
          pageSize !== this.selectorPage.limit
        )
          return
        const root = response && response.data ? response.data : response
        const data = root && root.data && !Array.isArray(root.data) ? root.data : root
        const pagination = (data && data.pagination) || {}
        this.goods = Array.isArray(data && data.list) ? data.list : []
        this.selectorPage = {
          page: Number(pagination.page || page),
          limit: Number(pagination.per_page || pageSize),
          total: Number(pagination.total || 0)
        }
        this.selectorJumpPage = this.selectorPage.page
      } catch (error) {
        if (requestId === this.selectorRequestId && !this._isDestroyed)
          this.$message.error(error?.message || '商品查询失败')
      } finally {
        if (requestId === this.selectorRequestId) this.selectorLoading = false
      }
    },
    jumpSelectorPage() {
      if (this.selectorTab === 'selected') {
        const page = Math.min(this.selectedPageCount, Math.max(1, Number(this.selectedJumpPage) || 1))
        this.selectedPage = page
        this.selectedJumpPage = page
        return
      }
      const page = Math.min(this.selectorPageCount, Math.max(1, Number(this.selectorJumpPage) || 1))
      this.selectorJumpPage = page
      if (page !== this.selectorPage.page) this.loadGoods(page)
    },
    changeSelectorPage(page) {
      if (this.selectorTab === 'all') {
        this.loadGoods(page)
        return
      }
      this.selectedPage = Math.min(this.selectedPageCount, Math.max(1, Number(page) || 1))
      this.selectedJumpPage = this.selectedPage
    },
    changeSelectorPageSize(size) {
      this.selectorPage.limit = Number(size)
      this.selectedPage = Math.min(this.selectedPageCount, this.selectedPage)
      this.selectedJumpPage = this.selectedPage
      if (this.selectorTab === 'all') this.querySelector()
    },
    changeSelectorJumpPage(value) {
      if (this.selectorTab === 'all') this.selectorJumpPage = Number(value)
      else this.selectedJumpPage = Number(value)
    },
    syncSelectedPage() {
      this.selectedPage = Math.min(this.selectedPage, this.selectedPageCount)
      this.selectedJumpPage = this.selectedPage
    },
    togglePageSelection() {
      const ids = this.goods.map((good) => this.productId(good))
      if (this.isPageFullySelected) {
        this.selectorSelected = this.selectorSelected.filter((id) => !ids.includes(id))
        this.selectorSelectedGoods = this.selectorSelectedGoods.filter((good) => !ids.includes(this.productId(good)))
        this.syncSelectedPage()
        return
      }
      const shopId = Number(this.selectorSelectedGoods[0]?.shop_id || this.goods[0]?.shop_id)
      if (this.goods.some((good) => Number(good.shop_id) !== shopId))
        return this.$message.warning('只能选择同一家店铺的商品，请先筛选店铺')
      this.goods.forEach((good) => {
        if (!this.selectorSelected.includes(this.productId(good))) this.toggleGood(good)
      })
      this.syncSelectedPage()
    },
    isExcluded(good) {
      return this.excludedProductIds.includes(this.productId(good))
    },
    toggleExclude(good) {
      const id = this.productId(good)
      this.excludedProductIds = this.excludedProductIds.includes(id)
        ? this.excludedProductIds.filter((item) => item !== id)
        : [...this.excludedProductIds, id]
    },
    resetFilters() {
      this.filterValues = searchDefaults()
      this.previewGoods = []
      this.previewPage = { ...this.previewPage, page: 1, total: 0 }
      this.previewJumpPage = 1
      this.previewSignature = ''
      this.preview = false
    },
    toggleGood(good) {
      if (
        !this.selectorSelected.includes(this.productId(good)) &&
        this.selectorSelectedGoods.length &&
        Number(this.selectorSelectedGoods[0].shop_id) !== Number(good.shop_id)
      )
        return this.$message.warning('只能选择同一家店铺的商品')
      const id = this.productId(good)
      this.selectorSelected = this.selectorSelected.includes(id)
        ? this.selectorSelected.filter((item) => item !== id)
        : [...this.selectorSelected, id]
      this.selectorSelectedGoods = this.selectorSelectedGoods.some((item) => this.productId(item) === id)
        ? this.selectorSelectedGoods.filter((item) => this.productId(item) !== id)
        : [...this.selectorSelectedGoods, good]
      this.syncSelectedPage()
    },
    addReplace() {
      this.form.replaces.push({ find: '', value: '' })
    },
    removeReplace(index) {
      this.form.replaces.splice(index, 1)
    },
    resetMoreSearch() {
      this.moreSearchDraft = [...this.moreSearchFields]
    },
    openMoreSearch() {
      this.moreSearchDraft = [...this.moreSearchChecked]
      this.moreSearch = true
    },
    closeMoreSearch() {
      this.moreSearch = false
      this.moreSearchDraft = []
    },
    applyMoreSearch() {
      this.moreSearchChecked = this.moreSearchFields.filter((field) => this.moreSearchDraft.includes(field))
      this.closeMoreSearch()
    }
  }
}
</script>

<style scoped>
.bm-title {
  min-height: calc(100vh - 56px);
  background: #f5f6f8;
  color: #1a1a2e;
  font-family: 'Noto Sans SC', sans-serif;
}
.bm-title button,
.bm-title input,
.bm-title select,
.bm-title textarea {
  font: inherit;
}
.bm-title button {
  cursor: pointer;
}
.bm-title__head {
  background: #fff;
  border-bottom: 1px solid #e0e0ec;
  padding: 10px 20px 0;
}
.bm-title__crumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #999;
}
.bm-title__crumb button {
  height: 26px;
  padding: 0 10px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
}
.bm-title__crumb a {
  margin-left: auto;
  color: #1677ff;
}
.bm-title h1 {
  margin: 12px 0 8px;
  font: 600 18px 'Noto Serif SC', serif;
}
.bm-title__head nav {
  display: flex;
  gap: 22px;
}
.bm-title__head nav button {
  padding: 9px 6px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: #fff;
  color: #666;
  font-size: 13px;
}
.bm-title__head nav button.active {
  border-bottom-color: #c8443c;
  color: #c8443c;
  font-weight: 600;
}
.bm-title__body {
  padding: 14px 20px 82px;
}
.bm-title__filter {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px 14px;
  padding: 14px 16px 10px;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}
.bm-title__field label {
  display: block;
  margin-bottom: 4px;
  color: #666;
  font-size: 10px;
}
.bm-title__field input,
.bm-title__field select,
.bm-title__range input,
.rule-options input,
.rule-options select,
.rule-options textarea,
.bm-title__select-filter input {
  box-sizing: border-box;
  width: 100%;
  height: 28px;
  padding: 4px 8px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  font-size: 11px;
}
.bm-title__range {
  display: flex;
  align-items: center;
  gap: 5px;
}
.bm-title__datetime-range {
  width: 100%;
}
::v-deep(.bm-title__datetime-range.el-date-editor) {
  height: 28px;
}
::v-deep(.bm-title__datetime-range .el-range-input),
::v-deep(.bm-title__datetime-range .el-range-separator),
::v-deep(.bm-title__datetime-range .el-range__icon) {
  font-size: 11px;
  line-height: 20px;
}
.bm-title__range span {
  color: #999;
}
.bm-title__filter footer {
  grid-column: 1/-1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding-top: 9px;
  border-top: 1px solid #f0f0f0;
  font-size: 12px;
}
.bm-title__filter footer span {
  margin-right: auto;
  color: #999;
}
.bm-title__filter b {
  color: #1677ff;
}
.bm-title__filter button,
.bm-title__picked button,
.bm-title__small-modal footer button,
.bm-title__select-modal footer button {
  height: 28px;
  padding: 0 13px;
  border: 0;
  border-radius: 4px;
  background: #c8443c;
  color: #fff;
  font-size: 12px;
}
.bm-title__filter .plain,
.bm-title__small-modal .plain {
  border: 1px solid #e0e0ec;
  background: #fff;
  color: #666;
}
.bm-title__picked,
.bm-title__fail {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 14px;
  padding: 10px 14px;
  border: 1px solid #e0e0ec;
  border-radius: 6px;
  background: #fff;
  color: #666;
  font-size: 12px;
}
.bm-title__picked button {
  background: #1677ff;
}
.bm-title__picked span {
  color: #1677ff;
}
.bm-title__fail {
  border-color: #ffccd2;
  background: #fff5f5;
  color: #1a1a2e;
}
.bm-title__fail label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  white-space: nowrap;
}
.bm-title__fail input[type='radio'] {
  -webkit-appearance: radio;
  -moz-appearance: radio;
  appearance: radio;
  width: 16px;
  height: 16px;
  min-width: 16px;
  margin: 0;
  cursor: pointer;
  accent-color: #c8443c;
  flex-shrink: 0;
}
.bm-title__methods {
  overflow: hidden;
  margin-top: 14px;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}
.bm-title__methods > header {
  padding: 10px 14px;
  border-bottom: 1px solid #e0e0ec;
  background: #f5f0e8;
  font-size: 12px;
  font-weight: 600;
}
.bm-title__methods > header i {
  display: inline-block;
  width: 3px;
  height: 14px;
  margin-right: 7px;
  border-radius: 2px;
  background: #c8443c;
  vertical-align: middle;
}
.bm-title__methods article {
  padding: 12px 14px;
  border-bottom: 1px solid #e0e0ec;
  font-size: 12px;
}
.bm-title__methods article:last-child {
  border-bottom: 0;
}
.bm-title__method-name {
  font-weight: 500;
}
.rule-options {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 10px 0 0 22px;
  color: #666;
}
.rule-options input {
  width: 190px;
}
.rule-options input.long {
  width: 360px;
}
.rule-options textarea {
  width: 360px;
  height: 62px;
  resize: vertical;
}
.rule-options select {
  width: 145px;
}
.rule-options small {
  color: #999;
  font-size: 10px;
}
.rule-options .warning {
  color: #c8443c;
}
.bm-title__replace {
  display: flex;
  align-items: center;
  gap: 8px;
}
.bm-title__replace button {
  height: 28px;
  padding: 0 10px;
  border: 1px solid #91caff;
  border-radius: 4px;
  background: #e6f4ff;
  color: #1677ff;
  font-size: 11px;
}
.bm-title__preview {
  overflow: hidden;
  margin-top: 14px;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}
.bm-title__preview header {
  padding: 10px 14px;
  border-bottom: 1px solid #e0e0ec;
  font-size: 12px;
}
.bm-title__preview header b {
  color: #1677ff;
}
.bm-title__preview header button {
  float: right;
  border: 0;
  background: none;
  color: #c8443c;
}
.bm-title__preview table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}
.bm-title__col-product {
  width: 45%;
}
.bm-title__col-new-title {
  width: 45%;
}
.bm-title__col-action {
  width: 10%;
}
.bm-title__preview th:nth-child(3),
.bm-title__preview td:nth-child(3) {
  text-align: center;
}
.bm-title__preview th {
  padding: 10px 16px;
  background: #f5f0e8;
  color: #666;
  font-size: 11px;
  font-weight: 500;
  text-align: left;
}
.bm-title__preview td {
  padding: 14px 16px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 12px;
  vertical-align: middle;
}
.bm-title__product-info {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.bm-title__preview p {
  display: -webkit-box;
  overflow: hidden;
  margin: 4px 0 0;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 18px;
}
.bm-title__preview small {
  color: #999;
}
.bm-title__product-ids {
  display: flex;
  align-items: center;
  gap: 12px;
}
.bm-title__empty-row td {
  height: 120px;
  color: #999;
  text-align: center;
}
.bm-title__preview textarea {
  width: 100%;
  padding: 5px 8px 18px;
  border: 1px solid rgb(224, 224, 236);
  border-radius: 4px;
  outline: none;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 11px;
  color: rgb(26, 26, 46);
  resize: none;
  box-sizing: border-box;
  line-height: 1.6;
}
.bm-title__preview td button {
  height: 24px;
  padding: 0 10px;
  border: 1px solid #91caff;
  border-radius: 3px;
  background: #e6f4ff;
  color: #1677ff;
  font-size: 10px;
  white-space: nowrap;
}
.bm-title__preview tr.is-excluded td {
  background: #fff7f7;
  color: #8c5a5a;
}
.bm-title__preview tr.is-excluded .bm-title__product-info,
.bm-title__preview tr.is-excluded textarea {
  opacity: 0.72;
}
.bm-title__preview td button.is-excluded {
  border-color: #f0a5a5;
  background: #fff1f0;
  color: #c8443c;
}
.bm-title__preview tr.is-error td {
  background: #fff7f7;
}
.bm-title__preview textarea.is-error {
  border-color: #f56c6c;
}
.bm-title__preview textarea.is-unchanged {
  background: #fff7e6;
}
.bm-title__preview-error {
  margin-top: 5px;
  color: #d93025;
  font-size: 11px;
  line-height: 1.5;
}
.bm-title__image {
  display: inline-flex;
  width: 56px;
  height: 56px;
  flex: 0 0 56px;
  align-items: center;
  justify-content: center;
  border: 1px solid #ffccd2;
  border-radius: 4px;
  background: #fff5f5;
  font-size: 16px;
}
.bm-title__pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
  padding: 0 14px;
  border-top: 1px solid #ebeef5;
  color: #666;
  font-size: 12px;
}
.bm-title__pagination-actions,
.bm-title__pagination-jump {
  display: flex;
  align-items: center;
  gap: 8px;
}
.bm-title__pagination ::v-deep(.el-pagination) {
  padding: 0;
}
.bm-title__pagination ::v-deep(.el-pager li),
.bm-title__pagination ::v-deep(.btn-prev),
.bm-title__pagination ::v-deep(.btn-next) {
  min-width: 28px;
  height: 28px;
  margin: 0 2px;
  border: 1px solid #dfe3eb;
  border-radius: 3px;
  line-height: 26px;
}
.bm-title__pagination ::v-deep(.el-pager li.active) {
  border-color: #1677ff;
  color: #1677ff;
}
.bm-title__pagination-jump input {
  width: 34px;
  height: 28px;
  box-sizing: border-box;
  border: 1px solid #dfe3eb;
  border-radius: 3px;
  text-align: center;
}
.bm-title__bottom {
  position: fixed;
  left: var(--merchant-sidebar-width, 210px);
  right: 0;
  z-index: 20;
  bottom: 0;
  display: flex;
  width: auto;
  max-width: none;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: hidden;
  flex-wrap: nowrap;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  border-top: 1px solid #e0e0ec;
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  font-size: 12px;
}
.bm-title__bottom button {
  min-width: 0;
  flex: 0 1 auto;
  height: 30px;
  padding: 0 14px;
  border: 0;
  border-radius: 4px;
  color: #fff;
}
.bm-title__bottom .preview {
  background: #1677ff;
}
.bm-title__bottom .start {
  margin-left: auto;
  margin-right: 50px;
  padding: 0 28px;
  background: #52c41a;
}
.bm-title__bottom .time {
  background: #fff;
  color: #666;
  border: 1px solid #e0e0ec;
}
.bm-title__mask {
  position: fixed;
  z-index: 3000;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(3px);
}
.bm-title__select-modal,
.bm-title__small-modal {
  width: min(760px, 100%);
  overflow: hidden;
  border: 1px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
}
.bm-title__select-modal {
  width: min(1120px, 100%);
}
.bm-title__small-modal {
  width: min(400px, 100%);
}
.bm-title__select-modal > header,
.bm-title__small-modal > header {
  display: flex;
  justify-content: space-between;
  padding: 12px 18px;
  border-bottom: 1px solid #e0e0ec;
  background: #fafafa;
  font-size: 14px;
}
.bm-title__select-modal > header button,
.bm-title__small-modal > header button {
  width: 24px;
  height: 24px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
  font-size: 18px;
}
.bm-title__select-modal nav {
  display: flex;
  padding: 0 18px;
  border-bottom: 1px solid #e0e0ec;
}
.bm-title__select-modal nav button {
  padding: 10px 14px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: #fff;
  color: #666;
  font-size: 12px;
}
.bm-title__select-modal nav button.active {
  border-bottom-color: #1677ff;
  color: #1677ff;
}
.bm-title__select-filter {
  align-items: center;
  flex-wrap: wrap;
  display: flex;
  gap: 8px;
  padding: 10px 18px;
  background: #fafafa;
}
.bm-title__select-filter input {
  width: 160px;
}
.bm-title__select-filter .bm-title__selector-date {
  width: 290px;
}
.bm-title__select-filter .bm-title__selector-status,
.bm-title__select-filter .bm-title__selector-page-size {
  width: 130px;
}
.bm-title__select-filter button {
  height: 28px;
  padding: 0 12px;
  border: 0;
  border-radius: 4px;
  background: #1677ff;
  color: #fff;
  font-size: 11px;
}
.bm-title__select-modal main {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  max-height: 350px;
  padding: 14px 18px;
  overflow: auto;
}
.bm-title__select-modal main .bm-title__selector-all {
  grid-column: 1 / -1;
  font-size: 12px;
  color: #666;
}
.bm-title__select-modal main button {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  border: 2px solid #e0e0ec;
  border-radius: 6px;
  background: #fff;
  color: #1a1a2e;
  text-align: left;
}
.bm-title__select-modal main button.selected {
  border-color: #1677ff;
  background: #e6f4ff;
}
.bm-title__select-modal main .el-image {
  display: flex;
  width: 100%;
  height: 58px;
  align-items: center;
  justify-content: center;
  background: #fff5f5;
}
.bm-title__select-modal main .el-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.bm-title__select-modal main span {
  overflow: hidden;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bm-title__select-modal main small {
  color: #999;
  font-size: 10px;
}
.bm-title__select-modal footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 18px;
  border-top: 1px solid #e0e0ec;
  font-size: 12px;
}
.bm-title__selector-pager {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}
.bm-title__selector-pager input {
  width: 48px;
  height: 26px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  text-align: center;
}
.bm-title__select-modal footer .bm-title__selector-pager button {
  padding: 0 8px;
  background: #fff;
  color: #1677ff;
  border: 1px solid #91caff;
}
.bm-title__select-modal footer .bm-title__selector-pager button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.bm-title__selector-empty {
  grid-column: 1 / -1;
  padding: 28px 0;
  text-align: center;
  color: #999;
}
.bm-title__select-modal footer button {
  background: #1677ff;
}
.bm-title__small-modal main {
  padding: 24px 20px;
  font-size: 13px;
}
.bm-title__small-modal main label {
  display: flex;
  align-items: center;
  gap: 10px;
}
.bm-title__small-modal main input {
  height: 28px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
}
.bm-title__schedule-picker {
  width: 240px;
}
.bm-title__small-modal footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 18px;
  border-top: 1px solid #e0e0ec;
}
.bm-title__small-modal .success-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.bm-title__small-modal .success-message b {
  display: flex;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f6ffed;
  color: #52c41a;
  font-size: 28px;
}
.bm-title__small-modal .success-message p {
  margin: 12px 0 5px;
}
.bm-title__small-modal .success-message small {
  color: #999;
}
@media (max-width: 960px) {
  .bm-title__filter {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .bm-title__bottom {
    left: 0;
  }
}
@media (max-width: 720px) {
  .bm-title__filter {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .bm-title__select-modal main {
    grid-template-columns: repeat(3, 1fr);
  }
  .bm-title__bottom .start {
    margin-left: 0;
  }
}
@media (max-width: 520px) {
  .bm-title__head,
  .bm-title__body {
    padding-right: 12px;
    padding-left: 12px;
  }
  .bm-title__filter {
    grid-template-columns: 1fr;
  }
  .rule-options input,
  .rule-options input.long,
  .rule-options textarea {
    width: 100%;
  }
  .bm-title__select-modal main {
    grid-template-columns: repeat(2, 1fr);
  }
  .bm-title__bottom {
    gap: 6px;
    padding: 8px 12px;
  }
  .bm-title__bottom .start {
    padding: 0 12px;
  }
  .bm-title__bottom .preview {
    display: none;
  }
}
.bm-title__method-name {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #1a1a2e;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  cursor: pointer;
}
.bm-title__method-name input,
.rule-options input[type='checkbox'],
.rule-options input[type='radio'] {
  width: 14px;
  height: 14px;
  min-width: 14px;
  margin: 0;
  padding: 0;
  accent-color: #1677ff;
  cursor: pointer;
}
.rule-options {
  align-items: center;
  margin-top: 10px;
  padding-left: 22px;
  line-height: 28px;
}
.rule-options > label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  cursor: pointer;
}
.rule-options > span {
  flex-shrink: 0;
  color: #666;
  font-size: 12px;
}
.rule-options .bm-title__count-input,
.rule-options .bm-title__count-textarea {
  position: relative;
  line-height: normal;
}
.rule-options .bm-title__count-input input {
  width: 360px;
}
.rule-options .bm-title__count-input small,
.rule-options .bm-title__count-textarea small {
  position: absolute;
  right: 8px;
  bottom: 5px;
  color: #999;
  font: 10px 'JetBrains Mono', monospace;
}
.rule-options .bm-title__count-textarea textarea {
  width: 360px;
  padding-bottom: 18px;
}
.rule-options .bm-title__replace {
  width: 100%;
  gap: 8px;
}
.rule-options .bm-title__replace input {
  width: 160px;
}
.bm-title__replace .danger {
  border-color: #ffccd2;
  background: #fff5f5;
  color: #c8443c;
}
.rule-options .bm-title__inline {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.rule-options .bm-title__inline input:not([type='checkbox']):not([type='radio']) {
  width: 200px;
}
.rule-options select:disabled {
  background: #f5f5f5;
  color: #999;
}
.rule-options > .warning {
  display: block;
  width: 100%;
  line-height: 16px;
}
.bm-title__methods article {
  padding: 14px 14px 13px;
}
::v-deep(.bm-title__methods .el-checkbox__inner) {
  width: 14px;
  height: 14px;
  border-color: #d9c98d;
  border-radius: 3px;
}
::v-deep(.bm-title__methods .el-checkbox__inner:hover),
::v-deep(.bm-title__methods .el-checkbox__input.is-focus .el-checkbox__inner) {
  border-color: #d4a946;
}
::v-deep(.bm-title__methods .el-checkbox__input.is-checked .el-checkbox__inner),
::v-deep(.bm-title__methods .el-checkbox__input.is-indeterminate .el-checkbox__inner) {
  border-color: #d4a946;
  background: #d4a946;
}
::v-deep(.bm-title__methods .el-checkbox__label) {
  color: #1a1a2e;
  font-size: 12px;
}
::v-deep(.bm-title__methods .el-checkbox__input.is-checked + .el-checkbox__label) {
  color: #1a1a2e;
}
.bm-title__select {
  width: 160px;
  line-height: normal;
}
.bm-title__filter-select {
  display: block;
  width: 100%;
}
.bm-title__store-select {
  width: 220px;
}
.bm-title__stores,
.bm-title__filter footer > div {
  display: flex;
  align-items: center;
  gap: 8px;
}
.bm-title__filter .add-store {
  background: #722ed1;
}
.bm-title__filter .add-store:hover {
  background: #531dab;
}
::v-deep(.bm-title__select .el-input__inner),
::v-deep(.bm-title__filter-select .el-input__inner),
::v-deep(.bm-title__store-select .el-input__inner) {
  height: 28px;
  padding: 0 28px 0 8px;
  border-color: #e0e0ec;
  border-radius: 4px;
  color: #1a1a2e;
  font-size: 12px;
  line-height: 28px;
  text-align: left;
}
::v-deep(.bm-title__select .el-input__suffix),
::v-deep(.bm-title__filter-select .el-input__suffix),
::v-deep(.bm-title__store-select .el-input__suffix) {
  right: 7px;
}
::v-deep(.bm-title__select .el-input__icon),
::v-deep(.bm-title__filter-select .el-input__icon),
::v-deep(.bm-title__store-select .el-input__icon) {
  color: #999;
  font-size: 14px;
  line-height: 28px;
}
::v-deep(.bm-title__select .el-input__inner:focus),
::v-deep(.bm-title__filter-select .el-input__inner:focus),
::v-deep(.bm-title__store-select .el-input__inner:focus) {
  border-color: #d4a946;
}
.bm-title__filter .more-search {
  padding: 0 2px;
  background: transparent;
  color: #1677ff;
}
.bm-title__more-modal {
  width: min(540px, 100%);
  overflow: hidden;
  border: 1px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
}
.bm-title__more-modal > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px;
  border-bottom: 1px solid #e0e0ec;
  background: #fafafa;
  font-size: 14px;
}
.bm-title__more-modal > header button {
  width: 24px;
  height: 24px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
  font-size: 18px;
}
.bm-title__more-modal main {
  padding: 16px 18px;
}
.bm-title__more-modal .el-checkbox-group {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}
.bm-title__more-modal footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 18px;
  border-top: 1px solid #e0e0ec;
}
.bm-title__more-modal footer button {
  height: 28px;
  padding: 0 13px;
  border: 0;
  border-radius: 4px;
  background: #1677ff;
  color: #fff;
  font-size: 12px;
}
.bm-title__more-modal footer .plain {
  border: 1px solid #e0e0ec;
  background: #fff;
  color: #666;
}
::v-deep(.bm-title__more-modal .el-checkbox__inner) {
  width: 14px;
  height: 14px;
  border-color: #d9c98d;
  border-radius: 3px;
}
::v-deep(.bm-title__more-modal .el-checkbox__input.is-checked .el-checkbox__inner) {
  border-color: #d4a946;
  background: #d4a946;
}
::v-deep(.bm-title__more-modal .el-checkbox__label) {
  color: #1a1a2e;
  font-size: 12px;
}
.bm-title__filter > footer {
  justify-content: space-between;
}

.bm-title__selector-category {
  width: 150px;
  flex: 0 0 150px;
}
.bm-title__selector-platform-id,
.bm-title__selector-title {
  height: 32px;
  box-sizing: border-box;
  padding: 0 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  color: #606266;
}
.bm-title__selector-platform-id {
  width: 112px;
}
.bm-title__selector-title {
  width: 136px;
}
.bm-title__selector-platform-id:focus,
.bm-title__selector-title:focus {
  border-color: #409eff;
  outline: 0;
}
.bm-title__selector-date {
  width: 160px;
  flex: 0 0 160px;
}
.bm-title__selector-status {
  width: 92px;
  flex: 0 0 92px;
}
.bm-title__selector-query {
  height: 32px;
  padding: 0 12px;
  border: 0;
  border-radius: 4px;
  background: #1677ff;
  color: #fff;
  font-size: 11px;
}

/* 商品选择弹窗：与批量修改设计稿一致的紧凑卡片布局。 */
.bm-title__select-modal {
  width: min(860px, calc(100vw - 32px));
  border-color: #dcdfea;
  border-radius: 6px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.2);
}
.bm-title__select-modal > header {
  padding: 10px 16px;
  background: #fff;
  color: #1a1a2e;
}
.bm-title__select-modal nav {
  padding: 0 16px;
  background: #fafbff;
}
.bm-title__select-modal nav button {
  min-width: 80px;
  padding: 10px 12px;
  color: #4b5568;
}
.bm-title__select-filter {
  flex-wrap: nowrap;
  gap: 8px;
  min-height: 48px;
  padding: 8px 16px;
  border-bottom: 1px solid #eef0f6;
  background: #fff;
}
.bm-title__select-filter .bm-title__selector-category {
  width: 108px;
  flex: 0 0 108px;
}
.bm-title__select-filter input {
  width: 140px;
  height: 28px;
  box-sizing: border-box;
}
.bm-title__select-filter .bm-title__selector-date {
  width: 142px;
  flex: 0 0 142px;
}
.bm-title__select-filter .bm-title__selector-status {
  width: 100px;
  flex: 0 0 100px;
}
.bm-title__select-filter .bm-title__selector-page-size {
  width: 92px;
  flex: 0 0 92px;
}
.bm-title__select-filter button {
  flex: 0 0 auto;
}
.bm-title__selector-top-all {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-left: auto;
  color: #1a1a2e;
  font-size: 12px;
  white-space: nowrap;
  cursor: pointer;
}
.bm-title__selector-top-all input,
.bm-title__selector-image input {
  width: 14px;
  height: 14px;
  margin: 0;
  accent-color: #1677ff;
  cursor: pointer;
}
.bm-title__select-modal main {
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;
  min-height: 258px;
  max-height: 278px;
  padding: 12px 16px;
}
.bm-title__select-modal main .bm-title__selector-card {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 5px;
  padding: 0 6px 7px;
  overflow: hidden;
  border: 1px solid #d9ddeb;
  border-radius: 6px;
  background: #fff;
  color: #1a1a2e;
  cursor: pointer;
}
.bm-title__select-modal main .bm-title__selector-card.selected {
  border-color: #9fc7ff;
  background: #f6faff;
}
.bm-title__selector-card:focus {
  outline: 2px solid #9fc7ff;
  outline-offset: 1px;
}
.bm-title__selector-image {
  position: relative;
  height: 81px;
  margin: 0 -6px;
  background: #fff5f5;
}
.bm-title__select-modal main .bm-title__selector-image .el-image {
  width: 100%;
  height: 100%;
}
.bm-title__selector-image input {
  position: absolute;
  bottom: 6px;
  left: 7px;
}
.bm-title__select-modal main .bm-title__selector-card span {
  display: -webkit-box;
  min-height: 28px;
  overflow: hidden;
  color: #384055;
  font-size: 11px;
  line-height: 14px;
  text-overflow: initial;
  white-space: normal;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.bm-title__select-modal main .bm-title__selector-card small {
  overflow: hidden;
  color: #8c94a3;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bm-title__selector-empty {
  align-self: center;
}
.bm-title__select-modal footer {
  display: grid;
  grid-template-columns: 100px 1fr auto;
  min-height: 50px;
  padding: 0 16px;
  background: #fff;
}
.bm-title__selector-pager {
  justify-self: center;
}
.bm-title__selector-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.bm-title__select-modal footer .bm-title__selector-actions button {
  height: 32px;
  padding: 0 13px;
  border: 0;
  border-radius: 5px;
  background: #9fc7ff;
  color: #fff;
  font-size: 12px;
}
.bm-title__select-modal footer .bm-title__selector-actions button:not(:disabled):last-child {
  background: #1677ff;
}
.bm-title__select-modal footer .bm-title__selector-actions button.plain {
  border: 1px solid #d9ddeb;
  background: #fff;
  color: #667085;
}
.bm-title__select-modal footer .bm-title__selector-actions button:disabled {
  cursor: not-allowed;
}
@media (max-width: 760px) {
  .bm-title__select-filter {
    flex-wrap: wrap;
  }
  .bm-title__selector-top-all {
    margin-left: 0;
  }
  .bm-title__select-modal main {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    max-height: 360px;
  }
  .bm-title__select-modal footer {
    grid-template-columns: auto 1fr;
    gap: 8px;
    padding: 8px 12px;
  }
  .bm-title__selector-pager {
    grid-column: 1 / -1;
    grid-row: 2;
    justify-self: start;
    flex-wrap: wrap;
  }
  .bm-title__selector-actions {
    justify-self: end;
  }
}
</style>

<style>
.bm-title__schedule-popper {
  z-index: 3001 !important;
}
</style>

<style scoped src="./batch-modify.css"></style>
